import { createSlice } from "@reduxjs/toolkit";
import { fetchNews } from "../thunks/news";


const newsSlice = createSlice({
  name: "news",
  initialState: {
    news: [],
  },
  reducers: {
    setNews: (state, action) => {
      state.news = action.payload;
    },
  },
  extraReducers: (builders) => {
    builders.addCase(fetchNews.fulfilled, (state, action) => {
      state.news = action.payload
    })
  }

});
export const { setNews } = newsSlice.actions

export default newsSlice.reducer;
